import log from 'loglevel'

/**
 * Logs messages to document head.
 */
export function logToDocumentHead(message: string, logTargetEl: HTMLElement = document.head) {
  const logElement = document.createElement('script')
  logElement.type = 'text/plain'
  logElement.textContent = String(message)
  logElement.dataset['createdAt'] = String(new Date())
  logElement.dataset['type'] = 'log'
  logTargetEl.appendChild(logElement)
  log.debug('Added log to document.head:', message)
}
